<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'PAGES.STAGING.RESET_STAGING_MODAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <span>{{ 'PAGES.STAGING.RESET_STAGING_MODAL.DESCRIPTION' | translate }}</span>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-stroked-button [matMenuTriggerFor]="adv_menu" [disabled]="disableButton" color="accent">
      {{ 'PAGES.STAGING.RESET_STAGING_MODAL.BUTTONS.RESET' | translate }}
      <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #adv_menu="matMenu" color="accent">
      <button mat-menu-item (click)="resetStaging()" type="button">
        {{ 'PAGES.STAGING.RESET_STAGING_MODAL.BUTTONS.RESET_TO_LIVE_SITE' | translate }}
      </button>
      <button mat-menu-item (click)="showStagingModal()" type="button">
        {{ 'PAGES.STAGING.RESET_STAGING_MODAL.BUTTONS.RESET_STAGING_FROM_BACKUP' | translate }}
      </button>
      <button mat-menu-item (click)="showTemplateModal()" type="button">
        {{ 'PAGES.STAGING.RESET_STAGING_MODAL.BUTTONS.RESET_STAGING_FROM_TEMPLATE' | translate }}
      </button>
    </mat-menu>
  </mat-card-actions>
</mat-card>
